import { canv } from "@/canv/global.js";
import { getTarget } from "@/canv/utils.js";
import type { widgetOption } from "@/widgetMenu/widgetMenu";
import { wmBase } from "@/widgetMenu/wmBase";

type ArrowType = "none" | "filled" | "stroked" | "rombus" | "circle";

export class WmArrowEnd extends wmBase {
    constructor(options: widgetOption<string>[], lineSide = "last") {
        super();
        this.side = lineSide;
        this.options = options;
    }

    build() {
        const uniqValues = [...new Set(this.options.map((opt) => opt.value))];

        let viewUrl = this.aliases.none;
        if (uniqValues.length === 1 && uniqValues[0] in this.aliases) {
            viewUrl = this.aliases[uniqValues[0] as ArrowType];
        }

        const ifDividor = this.side === "first" ? `<div class="wm_dividor"></div>` : "";

        return `
            ${ifDividor}
            <div class="wm_arrowEnd wm_arrowEnd_${this.side}">
                ${viewUrl}
            </div>
        `;
    }

    init() {
        const item = document.querySelector<HTMLElement>(`.wm_arrowEnd_${this.side}`);
        item?.removeEventListener("click", this.showSubMenu, false);
        item?.addEventListener("click", this.showSubMenu, false);
    }

    showSubMenu = (e) => {
        const subm = document.getElementsByClassName("wm_arrowEnd_submenu")[0];
        if (subm) {
            subm.outerHTML = "";
            return;
        }
        const otherSubm = document.getElementsByClassName("widgetSubMenu")[0];
        if (otherSubm) {
            otherSubm.outerHTML = "";
        }

        canv.widgetMenu.subMenuBoss = "wm_arrowEnd";
        const submenu = document.createElement("div");
        submenu.classList.add("widgetSubMenu");
        submenu.classList.add("wm_arrowEnd_submenu");
        submenu.style.opacity = "0";
        document.body.prepend(submenu);

        submenu.innerHTML += this.submenuTemplate(this.aliases.none, "none");
        submenu.innerHTML += this.submenuTemplate(this.aliases.filled, "filled");
        submenu.innerHTML += this.submenuTemplate(this.aliases.stroked, "stroked");
        submenu.innerHTML += this.submenuTemplate(this.aliases.rombus, "rombus");
        submenu.innerHTML += this.submenuTemplate(this.aliases.circle, "circle");

        const items = document.querySelectorAll<HTMLElement>(".wm_arrowEnd_submenu_item");
        for (let i = 0; i < items.length; i++) {
            items[i].removeEventListener("click", this.itemClick, false);
            items[i].addEventListener("click", this.itemClick, false);
        }

        setTimeout(canv.widgetMenu.TryLocateMenu.bind(canv.widgetMenu), 50);
    };

    itemClick = (e: Event) => {
        const item = getTarget(e, "wm_arrowEnd_submenu_item");
        if (!item) return;

        const type = item.getAttribute("arrowType") as ArrowType;
        if (!type) return;

        this.applyValue(this.options, { side: this.side, endType: type });

        const menuItem = document.querySelector<HTMLElement>(`.wm_arrowEnd_${this.side}`);
        if (menuItem) {
            menuItem.innerHTML = this.aliases[type];
        }
    };

    submenuTemplate(view: string, type: ArrowType) {
        return `
            <div class="wm_arrowEnd_submenu_item" arrowType="${type}">
                ${view}
            </div>
        `;
    }

    name = "wm_arrowEnd";
    side = "last";
    options: widgetOption<string>[] = [];
    isStriked = false;
    aliases = {
        none: `
                <svg width="23" height="23" viewBox="0 0 30 116" fill="none" xmlns="http://www.w3.org/2000/svg">
                <line x1="14.5" y1="115.039" x2="14.5" y2="-6.10352e-05" stroke="black" stroke-width="7"/>
                <rect y="97" width="30" height="6" fill="white"/>
                </svg>
            `,
        filled: `
                <svg width="23" height="23" viewBox="0 0 45 123" fill="none" xmlns="http://www.w3.org/2000/svg">
                <line x1="22.5" y1="122.039" x2="22.5" y2="6.99994" stroke="black" stroke-width="7"/>
                <rect x="8" y="104" width="30" height="6" fill="white"/>
                <path d="M23 0L44.5 38.25H0L23 0Z" fill="black"/>
                </svg>
            `,
        stroked: `
                <svg width="23" height="23" viewBox="0 0 55 123" fill="none" xmlns="http://www.w3.org/2000/svg">
                <line x1="27.5" y1="122.039" x2="27.5" y2="6.99994" stroke="black" stroke-width="7"/>
                <rect x="13" y="104" width="30" height="6" fill="white"/>
                <line x1="26.7018" y1="4.77502" x2="52.13" y2="35.6522" stroke="black" stroke-width="7"/>
                <line x1="28.3926" y1="5.24976" x2="2.68108" y2="35.8915" stroke="black" stroke-width="7"/>
                <path d="M28 0L33.5 7.5L24 5L28 0Z" fill="black"/>
                </svg>
            `,
        rombus: `
                <svg width="23" height="23" viewBox="0 0 40 125" fill="none" xmlns="http://www.w3.org/2000/svg">
                <line x1="19.5" y1="124.039" x2="19.5" y2="8.99994" stroke="black" stroke-width="7"/>
                <rect x="5" y="106" width="30" height="6" fill="white"/>
                <rect y="19.7969" width="28" height="28" transform="rotate(-45 0 19.7969)" fill="black"/>
                </svg>
            `,
        circle: `
                <svg width="23" height="23" viewBox="0 0 28 125" fill="none" xmlns="http://www.w3.org/2000/svg">
                <line x1="13.5" y1="124.039" x2="13.5" y2="8.99994" stroke="black" stroke-width="7"/>
                <circle cx="14" cy="14" r="14" fill="black"/>
                </svg>
            `,
    };
}
